define.alias("shared/utils/plans-data/index", "media/utils/plans-data");